import { createSelector } from '@reduxjs/toolkit';
import { CartAppState } from '@cart-js/core';

type CartItemCountTextType = string | undefined;

export const getCartItemCountText = (cartItemCount: number): CartItemCountTextType => {
    if (cartItemCount < 1) {
        return undefined;
    }

    return cartItemCount > 99 ? '99+' : cartItemCount.toString();
};

export const DummyIcon: React.FC = () => null;
DummyIcon.displayName = 'DummyShoppingCartIcon';

export const selectHeaderShoppingCartProps = createSelector(
    (cartState: CartAppState) => cartState.product.summary.countSummary.activeItems,
    (cartCount) => {
        const icon = DummyIcon; // This prop is not used for rendering, but is required (might be obsolete code)
        const cartItemCountText = getCartItemCountText(cartCount);
        return { icon, cartItemCountText, totalItems: cartCount };
    },
);
